// import React from 'react';
// import logo from './logo.svg';
import './App.scss';
import "react-toastify/dist/ReactToastify.css";
import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Menu from "./common/Menu";
import Profile from "./pages/profile/profile";
import User from "./pages/user/user";
import Login from "./pages/login/login";
import Logout from "./pages/logout/logout";
import RegisterPage from "./pages/registration/registration";
import ProtectedRoute from "./common/protectedRoute";
import CreateRecommendation from "./pages/createRecommendation/createRecommendation";
import CreateSharelist from "./pages/createSharelist/createSharelist"
import ListRecommendation from "./pages/listRecommendation/listRecommendation";
import Friends from "./pages/friends/friends";
import Sharelist from "./pages/sharelist/sharelist";
import Shares from "./pages/sharelist/shares";
import SharelistById from "./pages/sharelistById/sharelistById";
import EditSharelist from "./pages/editSharelist/editSharelist";
import ExplorePage from "./pages/explore/explore";
import IdentityService from "./common/identityService";
import SearchUser from "./pages/searchUser/searchUser";
import ListShares from "./pages/listShares/listShares";
// import Store from "store";
import { ToastContainer, toast } from "react-toastify";

const AWS = require("aws-sdk");

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      userRecs: [],
      currentRecList: {},
      selectedSharelist: {},
      displayMenu: true,
      selectedMarker: null,
    };
  }

  async componentDidMount() {
    const isLoggedIn = await IdentityService.isLoggedIn();
    this.setState({
      isLoggedIn,
    });
  }

  notifyInfo(message, autoClose) {
    toast(
      message, {
      position: "top-right",
      autoClose: autoClose,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
    }
    );
  }

  notifyFailure(message, autoClose) {
    toast.error(
      message, {
      position: "top-right",
      autoClose: autoClose,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
    }
    );
  }

  setIsLoggedIn = isLoggedIn => {
    this.setState({
      isLoggedIn
    });
  };

  setDisplayMenu = displayMenu => {
    this.setState({
      displayMenu
    });
  };

  setCurrentRecList = (name, list) => {
    this.setState({
      currentRecList:
      {
        name: name,
        list: list,
      }
    });
  }

  setUserRecs = recs => {
    this.setState({
      userRecs: recs
    });
  }

  setSelectedMarker = (marker) => {
    console.log("Setting marker to parent: ", JSON.stringify(marker))
    this.setState({
      selectedMarker: marker
    });
  }

  setSelectedSharelist = (sharelist) => {
    this.setState({
      selectedSharelist: sharelist
    })
  }
  
  renderMenu = () => {

    if(this.state.displayMenu){
      return <Menu />;
    }

  }

  render() {
    return (
      <>
        <Router>
          {this.renderMenu()}
          <Container id="parent-container">
            <ToastContainer autoClose={1500} />
            <Switch>
              <ProtectedRoute
                exact={true}
                component={<Profile
                  setSelectedSharelist={this.setSelectedSharelist}
                  setIsLoggedIn={this.setIsLoggedIn}
                  isLoggedIn={this.state.isLoggedIn}
                  setUserRecs={this.setUserRecs}
                  getUserRecs={this.getUserRecs}
                  userRecs={this.state.userRecs}
                  setCurrentRecList={this.setCurrentRecList}
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                />}
                path="/profile"
              />
              <Route exact path="/login">
                <Login
                  setIsLoggedIn={this.setIsLoggedIn}
                  isLoggedIn={this.state.isLoggedIn}
                  setDisplayMenu={this.setDisplayMenu}
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                />
              </Route>
              <Route exact path="/logout">
                <Logout 
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                />
              </Route >
              <Route exact path="/profile/friends">
                <Friends />
              </Route >
              <Route exact path="/searchUser">
                <SearchUser
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure} 
                />
              </Route >
              <Route exact path="/registration">
                <RegisterPage
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure} 
                />
              </Route >
              <ProtectedRoute
                exact={true}
                component={<CreateRecommendation
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                  selectedMarker={this.state.selectedMarker}
                  setSelectedMarker={this.setSelectedMarker}
                />}
                path="/createRecommendation"
                setIsLoggedIn={this.setIsLoggedIn}
                isLoggedIn={this.state.isLoggedIn}
              />
              <Route exact path="/profile/listRecommendation">
                <ListRecommendation
                  userRecs={this.state.userRecs}
                  currentRecList={this.state.currentRecList}
                  setCurrentRecList={this.setCurrentRecList}
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                />
              </Route>
              <Route exact path="/user/listRecommendation">
                <ListRecommendation
                  userRecs={this.state.userRecs}
                  currentRecList={this.state.currentRecList}
                  setCurrentRecList={this.setCurrentRecList}
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                />
              </Route>
              <Route exact path="/explore">
                <ExplorePage
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                  setSelectedMarker={this.setSelectedMarker}
                />
              </Route>
              <Route exact path="/editSharelist">
                <EditSharelist
                  userRecs={this.state.userRecs}
                  selectedSharelist={this.state.selectedSharelist}
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure} 
                />
              </Route>
              <Route exact path="/profile/viewSharelist">
                <Sharelist
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                  setSelectedSharelist={this.setSelectedSharelist}
                  selectedSharelist={this.state.selectedSharelist}
                />
              </Route>
              <Route exact path="/profile/viewSharelist/shares">
                <Shares
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                  setSelectedSharelist={this.setSelectedSharelist}
                  selectedSharelist={this.state.selectedSharelist}
                />
              </Route>
              <Route exact path="/profile/friends/:id">
                <Friends
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                />
              </Route>
              <Route exact path="/user/:id">
                <User
                  setSelectedSharelist={this.setSelectedSharelist}
                  setIsLoggedIn={this.setIsLoggedIn}
                  isLoggedIn={this.state.isLoggedIn}
                  setUserRecs={this.setUserRecs}
                  getUserRecs={this.getUserRecs}
                  userRecs={this.state.userRecs}
                  setCurrentRecList={this.setCurrentRecList}
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                />
              </Route>
              <Route exact path="/user/friends/:id">
                <Friends/>
              </Route>
              <Route exact path="/user/sharelist/:id">
                <SharelistById
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                  setSelectedSharelist={this.setSelectedSharelist}
                  selectedSharelist={this.state.selectedSharelist}
                />
              </Route>
              <ProtectedRoute
                exact={true}
                component={<CreateSharelist 
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure} 
                />}
                path="/createSharelist"
                setIsLoggedIn={this.setIsLoggedIn}
                isLoggedIn={this.state.isLoggedIn}
              />
              <Route exact path="/getUserSharedSharelists">
                <ListShares
                  notifyInfo={this.notifyInfo}
                  notifyFailure={this.notifyFailure}
                />
              </Route>
            </Switch>
          </Container>
        </Router>
      </>
    );
  }
}

export default App;